import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVolumeMax = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M13.25 6.75c2 1 2 5.5 0 6.5m2-9.5c4 3 4 9.5 0 12.5m-6-12.5v12.5l-2.372-2.19c-.299-.276-.448-.413-.617-.516-.2-.123-.421-.21-.652-.255-.194-.039-.397-.039-.804-.039-.984 0-1.475 0-1.86-.17a2 2 0 0 1-1.026-1.025c-.169-.384-.169-.877-.169-1.86v-.39c0-.984 0-1.475.17-1.86a2 2 0 0 1 1.025-1.026c.385-.169.876-.169 1.86-.169.407 0 .61 0 .804-.039a2 2 0 0 0 .652-.255c.169-.103.318-.24.617-.516L9.25 3.75Z"
	})]
});
const ForwardRef = forwardRef(SvgVolumeMax);
export { ForwardRef as ReactComponent };
